import { useEffect, useState } from 'react';
import { getPositionIndex } from './animations';
import { useImagesLoader } from './use-images-loader';
import { useImagesUrl } from './use-images-url';
import { Animation, ThemeScroll } from '../FeatureAppTypes';

export interface UsePositionImageProps {
  position: number;
  animation: Animation;
  theme: ThemeScroll;
}

/**
 * Select speciffic image from sequence in relation to scroll position
 */
export const usePositionImage = ({ position, animation, theme }: UsePositionImageProps) => {
  const { imagesUrls, alt } = useImagesUrl(animation, theme);
  const images = useImagesLoader({ imagesUrls, alt, theme });
  const [image, setImage] = useState<HTMLImageElement>();

  useEffect(() => {
    setImage(images.get(getPositionIndex(position, imagesUrls.length)));
  }, [position, images]);

  return image;
};
